import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class Earth extends PIXI.Container {

  constructor(x, y, asset, appearingScreenPercent, game) {
    super();

    // top left position
    this.pos = {
      x: x,
      y: y
    }

    this.asset = asset;
    this.sprite = null;

    this.build();
  }

  build() {
    this.sprite = new PIXI.Sprite(this.asset);
    // Make earth rotate from the center
    this.sprite.anchor.set(0.5, 0.5);

    this.position.x = this.pos.x;
    this.position.y = this.pos.y;

    this.addChild(this.sprite);

    this.mainAnimation = gsap.timeline({
      // paused: true,
      repeat: -1,
    });

    this.mainAnimation.to(this,
      {
        pixi: {
          rotation: 360
        },
        repeat: -1,
        ease: 'linear',
        duration: 80.0,
      }
    );
  }


}
